export enum PageSectionType {
	PROFILE = 'profile',
	RECOMMENDATIONS = 'recommendations',
	SETTINGS = 'settings',
}
